import styled, { keyframes } from 'styled-components';
import { THEME } from '../../../themes';

const pulseAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`;

const waveAnimation = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

interface SkeletonStyledProps {
  $width?: number | string;
  $height?: number | string;
  $borderRadius?: number | string;
  $isCircular?: boolean;
}

const getBorderRadius = (isCircular: boolean, borderRadius: number | string) => {
  if (isCircular) {
    return '50%';
  }
  
  return typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius || THEME.RADIUS.TIDY;
};

export const SkeletonContainer = styled.div<SkeletonStyledProps>`
  display: inline-block;
  width: ${({ $width }) => typeof $width === 'number' ? `${$width}px` : $width || '100px'};
  height: ${({ $height }) => typeof $height === 'number' ? `${$height}px` : $height || '20px'};
  background-color: ${THEME.COLORS.LIGHT_GREY};
  border-radius: ${({ $isCircular, $borderRadius }) => getBorderRadius($isCircular, $borderRadius)};
  position: relative;
  overflow: hidden;
  animation: ${pulseAnimation} 1.2s ease-in-out infinite;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      transparent,
      ${THEME.COLORS.PURE_WHITE},
      transparent
    );
    animation: ${waveAnimation} 3s ease-in-out infinite;
  }
`;
